<!-- No local <ngx-ui-loader> here - this.uiLoader.start()/stop() below target
     the global default ("master") loader via NgxUiLoaderService, and this
     modal opens on top of full-calender-component, which already renders its
     own master loader element. A second bare <ngx-ui-loader> here registered
     a duplicate binding for the same ID whenever both were mounted at once
     (confirmed: SC-SAAS-FRONTEND-X). -->
<div class="modal-content" ngbAutofocus>

  <div class="modal-header border-0 justify-content-end">

    <div *ngIf="modalData?.event?.canEdit && (profileDetails?.uuid === modalData?.event?.user?.uuid) && modalData.event?.meetingLocationType !== 'in_person'"
      (click)="handleEditEvent()" class="btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-primary me-2"
      data-bs-toggle="tooltip" data-bs-dismiss="click" title="" id="kt_modal_view_event_edit"
      data-bs-original-title="Edit Event">
      <span class="svg-icon svg-icon-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path opacity="0.3"
            d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
            fill="currentColor"></path>
          <path
            d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
            fill="currentColor"></path>
        </svg>
      </span>
    </div>
    <div *ngIf="modalData?.event?.canDelete" class="btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-danger me-2"
      (click)="handleDeleteEvent()" data-bs-toggle="tooltip" data-bs-dismiss="click" title=""
      id="kt_modal_view_event_delete" data-bs-original-title="Delete Event">
      <span class="svg-icon svg-icon-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
            fill="currentColor"></path>
          <path opacity="0.5"
            d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
            fill="currentColor"></path>
          <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor">
          </path>
        </svg>
      </span>
    </div>

    <div class="btn btn-icon btn-sm btn-color-gray-500 btn-active-icon-primary" (click)="closeModal()"
      data-bs-toggle="tooltip" title="" data-bs-dismiss="kt_modal_view_event_edit" data-bs-original-title="Hide Event">

      <span class="svg-icon svg-icon-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
            fill="currentColor"></rect>
          <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor">
          </rect>
        </svg>
      </span>

    </div>

  </div>

  <div class="modal-body pt-0 pb-10 px-lg-12">

    <div class="d-flex">
      <!-- <span class="svg-icon svg-icon-1 svg-icon-muted me-5">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path opacity="0.3"
            d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z"
            fill="currentColor"></path>
          <path
            d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z"
            fill="currentColor"></path>
          <path
            d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z"
            fill="currentColor"></path>
        </svg>
      </span> -->

      <div class="position-relative me-5">
        <p class="calendar mb-0 pb-0">{{modalData?.event?.dateFormatted}} <em>{{modalData?.event?.month}}</em></p>
      </div>



      <div class="mb-3 w-100">


        <div class="d-flex align-items-center justify-content-between">
          <span class="fs-4 fw-bolder" data-kt-calendar="event_name">{{modalData?.event?.meetingTitle}}</span>

          <a class="d-flex align-items-center text-black border fs-7 py-1 px-2 ms-5 cursor-pointer rounded" (click)="closeModal()"
          style="border-color: #c6c6c6 !important;"
          target="_blank"
            [routerLink]="'/chat/conversations/' +modalData?.event?.connectionGroupUUID"
            *ngIf="modalData?.event?.connectionGroupUUID && brandDetails?.features?.chat">
            <i class="me-2 bi bi-chat-left-dots fs-6 header-icons-font-size"></i>
            Chat
          </a>
        </div>

        <span data-kt-calendar="event_start_date" class="mb-1 d-flex align-items-center">

          <ng-container *ngIf="modalData.event.meetingType !== 'job-interview' || profileDetails?.accountType !== ACCOUNT_TYPE.STARTUP;else jobseekerName">
            {{modalData.event.receiver.name }}
            <a [href]="modalData.event?.receiver?.profileUrl" target="_blank" >
              ({{modalData.event.receiver.companyName || modalData.event.receiver?.startup?.companyName}})
            </a>
          </ng-container>

          <ng-template #jobseekerName>
            {{modalData.event.jobApplication.applicantName }}
          </ng-template>


        </span>


        <p class="text-gray-600 fs-7 mt-1 mb-0">
          {{tConvert(modalData?.event?.timeFrom,modalData?.event?.date)}} - {{ tConvert(modalData?.event?.timeTo,
          modalData?.event?.date)}}



          <span class="badge badge-dark badge-sm ms-3"
            *ngIf="!modalData?.event?.isAccepted && !modalData?.event?.isRejected">
            Pending Acceptance
          </span>
        </p>
        <!-- <div class="fs-6" data-kt-calendar="event_description">{{modalData?.event?.date | date :'MMM d, y'}}
        </div> -->

      </div>
    </div>


    <div class="mt-4 w-100  text-center d-flex align-items-center justify-content-between"
      *ngIf="modalData?.event?.meetingLocationType">
      <span class="text-truncate d-flex">
        <b>Meeting Mode:</b> &nbsp; <span class="meeting-attr" [innerHTML]="meetingModelLabel[modalData?.event?.meetingLocationType]"></span>
      </span>
    </div>


    <div class="mt-4 w-100 d-flex align-items-center justify-content-between"
      *ngIf="modalData?.event?.meetingDescription">
      <span class="d-flex">
        <b>Agenda:</b> &nbsp; <span class="meeting-attr" [innerHTML]="modalData?.event?.meetingDescription"></span>
      </span>
    </div>


    <div class="mt-4 mb-4 w-100   text-center d-flex align-items-center justify-content-between"
    *ngIf="modalData.event?.meetingLocationType === 'in_person'">
      <span class="text-truncate d-flex">
        <b>Venue:</b> &nbsp; <span class="meeting-attr" [innerHTML]="modalData?.event?.meetingInPersonLocation"></span>
      </span>
    </div>


    <div class="separator separator-dashed my-4"></div>


    <!-- <div class="mt-4">
      <span class="fw-bolder fs-6 me-2">Participants: </span>
      <div class="d-flex align-items-center mb-2 mt-2" *ngIf="modalData?.event?.receiver">

        <div class="fs-6">
          <span data-kt-calendar="event_start_date">{{ modalData.event.receiver.name }}
            <a [href]="modalData.event.receiver.profileUrl" target="_blank">
              ({{modalData.event.receiver.companyName}})
            </a>
          </span>
        </div>

      </div>
      <div class="d-flex align-items-center mb-9" *ngIf="modalData?.event?.user">
        <div class="fs-6">
          <span data-kt-calendar="event_start_date">{{ modalData.event.user.name }}
            <a [href]="modalData.event.user.profileUrl" target="_blank">
              ({{modalData.event.user.companyName}})
            </a>
          </span>
        </div>

      </div>
    </div> -->



    <!-- <div class="d-flex justify-content-between"> -->
    <!-- <div>
        <div class="d-flex align-items-center mb-2">
          <span class="svg-icon svg-icon-1 svg-icon-success me-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <circle fill="currentColor" cx="12" cy="12" r="8"></circle>
            </svg>
          </span>
          <div class="fs-6">
            <span class="fw-bolder me-2">Starts</span>
            <span data-kt-calendar="event_start_date">{{ tConvert(modalData?.event?.timeFrom,
              modalData?.event?.date) }}</span>
          </div>

        </div>
        <div class="d-flex align-items-center mb-9">
          <span class="svg-icon svg-icon-1 svg-icon-danger me-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <circle fill="currentColor" cx="12" cy="12" r="8"></circle>
            </svg>
          </span>
          <div class="fs-6">
            <span class="fw-bolder me-2">Ends</span>
            <span data-kt-calendar="event_end_date">{{ tConvert(modalData?.event?.timeTo,
              modalData?.event?.date)}}</span>
          </div>

        </div>
      </div> -->
    <!-- <div *ngIf="modalData?.event?.date && !isMeetingExpired">
        <add-to-calendar-button [attr.name]="modalData?.event?.meetingTitle"
          [attr.description]="modalData?.event?.meetingDescription" [attr.location]="meetingUrl"
          timeZone="Asia/Calcutta" location="World Wide Web"
          options="'Apple','Google','iCal','Yahoo','Microsoft365','MicrosoftTeams','Outlook.com'" style="width: 100%;"
          [attr.startTime]="formatTo24Hour(modalData?.event?.timeFrom)"
          [attr.endTime]="formatTo24Hour(modalData?.event?.timeTo)" [attr.startDate]="modalData.event.date"
          trigger="click" label="Add to calender"></add-to-calendar-button>
      </div> -->
    <!-- </div> -->



    <div *ngIf="modalData?.event?.canReceiverAcceptReject" class="mt-4 alert p-5 alert-primary alert-width-100">
      <h3 class="mb-2">
        RSVP
      </h3>
      <div class="d-flex align-items-center justify-content-between gap-5">
        <button (click)="handleAcceptMeetingRequest()" type="button" id="kt_modal_add_event_submit"
          class="btn btn-success btn-sm ls-2 text-uppercase fw-boldest w-100">
          <span class="indicator-label">Accept</span>
        </button>

        <button (click)="handleRejectMeetingRequest()" type="button" id="kt_modal_add_event_submit"
          class="btn btn-danger btn-sm ls-2 text-uppercase fw-boldest w-100">
          <span class="indicator-label">Reject</span>
        </button>


        <div class="" *ngIf="(modalData.event?.canProposeTime) && !modalData?.event?.proposedDate">
          <button (click)="handleReschedule()" type="button" id="kt_modal_add_event_submit"
            class="btn btn-dark ls-2 btn-sm text-uppercase fw-boldest w-100 no-wrap">
            <span class="indicator-label">Propose new time</span>
          </button>
        </div>
      </div>
    </div>



    <div class=" d-flex w-100" *ngIf="modalData?.event?.canCreateFollowupMeeting &&
    modalData.event?.meetingLocationType !== 'in_person'">
      <button (click)="handleCreateFollowup()" type="button" id="kt_modal_add_event_submit"
        class="btn btn-theme text-white ls-2  text-uppercase fw-boldest mx-auto">
        <span class="indicator-label">Create Followup Meeting</span>
      </button>
    </div>




    <div class="alert alert-primary mt-4" *ngIf="modalData?.event?.proposedDate">
      <div class="d-flex align-items-center mb-3 justify-content-between">
        <h2 class="mb-0">Proposed time
        </h2>
        <span class="badge badge-dark badge-sm ms-3">
          Pending Action
        </span>
      </div>
      <div class="d-flex justify-content-between align-items-center">

        <div>
          <div class="fs-6" data-kt-calendar="event_description">{{modalData?.event?.proposedDate | date :'MMM d, y'}}
          </div>

          <div class="d-flex align-items-center mb-2 mt-4">
            <!-- <span class="svg-icon svg-icon-1 svg-icon-success me-5">
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                <circle fill="currentColor" cx="12" cy="12" r="8"></circle>
              </svg>
            </span> -->
            <span class="svg-icon svg-icon-1 svg-icon-danger me-5">
              <i class="bi  bi-clock fs-2 header-icons-font-size"></i>
            </span>
            <div class="fs-6">
              <span class="fw-bolder me-2">Starts</span>
              <span data-kt-calendar="event_start_date">{{ tConvert(modalData?.event?.proposedTimeFrom,
                modalData?.event?.proposedDate) }}</span>
            </div>

          </div>
          <div class="d-flex align-items-center ">
            <span class="svg-icon svg-icon-1 svg-icon-danger me-5">
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                <circle fill="currentColor" cx="12" cy="12" r="8"></circle>
              </svg>
            </span>
            <div class="fs-6">
              <span class="fw-bolder me-2">Ends</span>
              <span data-kt-calendar="event_end_date">{{ tConvert(modalData?.event?.proposedTimeTo,
                modalData?.event?.proposedDate)}}</span>
            </div>

          </div>
        </div>

        <div class="d-flex flex-column" *ngIf="modalData?.event?.canPerformAction">
          <button (click)="handleAccept()" type="button" id="kt_modal_add_event_submit"
            class="btn btn-success btn-sm ls-2 text-uppercase fw-boldest">
            <span class="indicator-label">Accept</span>
          </button>

          <button (click)="handleReject()" type="button" id="kt_modal_add_event_submit"
            class="btn btn-danger btn-sm ls-2 text-uppercase fw-boldest mt-2">
            <span class="indicator-label">Reject</span>
          </button>
        </div>
      </div>
    </div>

    <div class="d-flex  pt-6  align-items-center"
    [ngClass]="{
      'justify-content-between' : modalData.event?.canJoinMeeting,
      'justify-content-center' : !modalData.event?.canJoinMeeting
    }"
      *ngIf="(modalData.event?.isAccepted || modalData.event?.canJoinMeeting) && !isMeetingExpired">
      <!-- <div class="pt-6" *ngIf="(modalData.event?.canProposeTime) && !modalData?.event?.proposedDate">
        <button (click)="handleReschedule()" type="button" id="kt_modal_add_event_submit"
          class="btn btn-secondary ls-2 text-uppercase fw-boldest">
          <span class="indicator-label">Propose new time</span>
        </button>
      </div> -->

      <add-to-calendar-button [attr.name]="modalData?.event?.meetingTitle" *ngIf="modalData.event?.isAccepted"
        [attr.description]="modalData?.event?.meetingDescription" [attr.location]="meetingUrl" timeZone="Asia/Calcutta"
        location="World Wide Web"
        options="'Apple','Google','iCal','Yahoo','Microsoft365','MicrosoftTeams','Outlook.com'"
        [attr.startTime]="formatTo24Hour(modalData?.event?.timeFrom)"
        [attr.endTime]="formatTo24Hour(modalData?.event?.timeTo)" [attr.startDate]="modalData.event.date"
        trigger="click" label="Add to calender"></add-to-calendar-button>


      <div class="" *ngIf="modalData.event?.canJoinMeeting && modalData.event?.meetingLocationType !== 'in_person'">
        <button (click)="meetingDetail(modalData?.event)" type="button" id="kt_modal_add_event_submit"

          class="btn btn-theme text-white ls-2 text-uppercase fw-boldest no-wrap">
          <span class="indicator-label">Go to meeting</span>
        </button>
      </div>
    </div>


    <div class="resume-banner2 mt-8" *ngIf="modalData.event?.meetingType !== 'job-interview'">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <span class="fw-bolder me-2  fs-3 text-primary">Your Notes</span>
        <div>
          <button class="btn btn-secondary btn-sm " (click)="onEditNote()">
            Edit
          </button>
          <button class="btn btn-secondary btn-sm  ms-4" (click)="onShareNote()"
          [disabled]="!modalData?.event?.meetingsNotes?.[0]?.notes"
          *ngIf="!modalData?.event?.meetingsNotes?.[0]?.isShared">
            Share Notes
          </button>
        </div>
      </div>
      <div class="separator separator-custom separator-dashed mt-2 mb-4"></div>

      <ng-container *ngIf="!editNoteMode">

        <div *ngIf="modalData?.event?.meetingsNotes && modalData?.event?.meetingsNotes?.length">
          {{modalData?.event?.meetingsNotes?.[0]?.notes}}
        </div>

        <div *ngIf="!modalData?.event?.meetingsNotes || !modalData?.event?.meetingsNotes?.length">
          No Notes found
        </div>
      </ng-container>

      <ng-container *ngIf="editNoteMode">
        <textarea class="form-control" placeholder="Enter your notes..." id="keyInvestments" rows="3"
          [(ngModel)]="meetingNote"></textarea>

        <button class="btn btn-dark btn-sm mt-3" (click)="onUpdateNote()" [disabled]="!meetingNote">
          Update
        </button>
      </ng-container>

    </div>



    <div class="resume-banner2 mt-8" *ngIf="modalData?.event?.sharedMeetingNotes?.[0]?.notes">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <span class="fw-bolder me-2  fs-3 text-primary">Shared Notes</span>
      </div>
      <div class="separator separator-custom separator-dashed mt-2 mb-4"></div>

      <ng-container>

        <div *ngIf="modalData?.event?.sharedMeetingNotes && modalData?.event?.sharedMeetingNotes?.length">
          {{modalData?.event?.sharedMeetingNotes?.[0].notes}}
        </div>

        <div *ngIf="!modalData?.event?.sharedMeetingNotes || !modalData?.event?.sharedMeetingNotes?.length">
          No Notes found
        </div>
      </ng-container>
    </div>

  </div>

</div>
